import { VisitsByDayOfWeekData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { CA_LIGHT_BLUE_COLOR } from '@utils/colorGenerator';
import { AXIS_COLOR, baseChart } from './baseChart';
import { SUBHEADER_FONT_SIZE } from '@components/shared/Layout/ReportSectionCardHeader';
import Highcharts from 'highcharts';

const DATE_LABELS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export const buildChartOptions = (
  data: VisitsByDayOfWeekData
): Highcharts.Options => ({
  ...baseChart,

  chart: {
    type: 'area',
    spacing: [50, 50, 15, 50],
  },

  series: [
    {
      type: 'area',
      dataLabels: {
        enabled: false,
      },
      data: [
        data.monday,
        data.tuesday,
        data.wednesday,
        data.thursday,
        data.friday,
        data.saturday,
        data.sunday,
      ],
      color: CA_LIGHT_BLUE_COLOR,
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      lineWidth: 0,
    },
  ],

  tooltip: {
    enabled: true,
    headerFormat: '',
    pointFormatter() {
      return [DATE_LABELS[this.x], this.y].join(': ');
    },
  },

  xAxis: {
    startOnTick: false,
    endOnTick: false,
    minPadding: 0,
    maxPadding: 0,
    tickAmount: 7,
    tickLength: 5,
    tickColor: AXIS_COLOR,
    labels: {
      overflow: 'allow',
      formatter() {
        return DATE_LABELS[this.value as number] ?? ''; // TODO: this.value can be a string
      },
      style: {
        fontSize: SUBHEADER_FONT_SIZE,
      },
    },
  },

  yAxis: {
    lineColor: AXIS_COLOR,
    lineWidth: 1,
    gridLineWidth: 0,
    tickColor: AXIS_COLOR,
    tickLength: 5,
    tickWidth: 1,
    labels: {
      enabled: true,
      style: {
        fontSize: SUBHEADER_FONT_SIZE,
      },
    },
    title: {
      text: 'Visit Index',
    },
  },
});
